import { Badge } from "@merge-api/merge-javascript-shared";
import { CheckCircle, Clock, Columns, Layers, XCircle, Zap } from "lucide-react";
import { SyncPlanConfig } from "./types";

const SyncPlanHeader = ({ config }: { config: SyncPlanConfig }) => {
  const priorityCount = new Set(config.blueprint_priorities.map((b) => b.priority)).size;
  const bpCount = config.blueprint_priorities.length;
  const maxConcurrentBlueprints = config.maximum_concurrent_blueprints;

  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-center gap-2">
        <Badge color={config.active ? "green" : "red"} className="flex items-center gap-1.5">
          {config.active ? <CheckCircle size={12} /> : <XCircle size={12} />}
          {config.active ? "Active" : "Inactive"}
        </Badge>
        <Badge color="gray" className="flex items-center gap-1.5">
          <Clock size={12} />
          Every {config.every} {config.period}
        </Badge>
        <Badge color="gray" className="flex items-center gap-1.5">
          <Layers size={12} />
          {priorityCount} priority stage{priorityCount !== 1 ? "s" : ""}
        </Badge>
        <Badge color="gray" className="flex items-center gap-1.5">
          <Zap size={12} />
          {bpCount} blueprint{bpCount !== 1 ? "s" : ""}
        </Badge>
        <Badge color="gray" className="flex items-center gap-1.5">
          <Columns size={12} />
          {maxConcurrentBlueprints != null
            ? `Max ${maxConcurrentBlueprints} concurrent blueprints`
            : "No maximum number concurrent blueprints"}
        </Badge>
      </div>
    </div>
  );
};

export default SyncPlanHeader;
